import React from 'react';
import {Helmet} from "react-helmet-async";

import '../styles/ttg/index.scss';

const PdfWrapper = ({ children, className, title }) => {
	return <>
		<Helmet>
			<meta charSet='UTF-8' />
			<meta name='viewport' content='width=device-width, initial-scale=1.0' />
			<meta httpEquiv='X-UA-Compatible' content='ie=edge' />
			<title>{title}</title>
		</Helmet>
		<div className={`ttg-pdf-wrapper ${className}`}>{children}</div>
	</>;
};

export default PdfWrapper;
